import React, { useState } from "react";
import { Container, ButtonGroup, Button } from "react-bootstrap";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarBoarding from "../../../components/SidebarDashboard";
import ReincidenciasCasos from "./ReincidenciasCasosDisciplinarios/ReincidenciasCasos";
import ReincidenciasAcciones from "./ReincidenciasAccionesDisciplinarias/ReincidenciasAcciones";

function Reincidencias() {
  const [show, setShow] = useState(false);
  const [selectedOption, setSelectedOption] = useState("reincidencias_casos"); // Estado de opciones
  const [showButtons, setShowButtons] = useState(true);

  // Función para mostrar/ocultar el sidebar
  const onShowSidebar = () => setShow(!show);

  // Función para cambiar la opción seleccionada
  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const toggleButtonsVisibility = () => {
    setShowButtons((prevState) => !prevState);
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarBoarding show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {/* Encabezado con opciones seleccionables */}
          <div className="my-4 d-flex justify-content-left">
            {showButtons && (
              <ButtonGroup>
                <Button
                  variant={
                    selectedOption === "reincidencias_casos"
                      ? "primary"
                      : "light"
                  }
                  onClick={() => handleOptionChange("reincidencias_casos")}
                >
                  Reincidencias Casos Disciplinarios
                </Button>
                <Button
                  variant={
                    selectedOption === "reincidencias_acciones"
                      ? "primary"
                      : "light"
                  }
                  onClick={() => handleOptionChange("reincidencias_acciones")}
                >
                  Reincidencias Acciones Disciplinarias
                </Button>
              </ButtonGroup>
            )}
          </div>

          {selectedOption === "reincidencias_casos" && (
            <ReincidenciasCasos
              toggleButtonsVisibility={toggleButtonsVisibility}
            />
          )}
          {selectedOption === "reincidencias_acciones" && (
            <ReincidenciasAcciones
              toggleButtonsVisibility={toggleButtonsVisibility}
            />
          )}
        </Container>
      </div>
    </>
  );
}

export default Reincidencias;
